import { ROUTE } from '@/config';
import { PermissionName } from '@/types';

/**
 * Determines the default landing page based on user permissions
 * Priority order:
 * 1. Orders page (order_and_shipment permission)
 * 2. Dashboard (dashboard permission)
 * 3. Finance (finance permission)
 * 4. Settings (always accessible as fallback)
 */
export const getDefaultRoute = (hasPermission: (...permissions: string[]) => boolean): string => {
  if (hasPermission(PermissionName.ORDER_AND_SHIPMENT)) return ROUTE.ORDERS;
  if (hasPermission(PermissionName.DASHBOARD)) return ROUTE.DASHBOARD;
  if (hasPermission(PermissionName.FINANCE)) return ROUTE.FINANCE;

  // If user has no permissions, redirect to Settings
  return ROUTE.SETTINGS;
};
